if (!customElements.get('section-testimonial')) {
  customElements.define(
    'section-testimonial',
    class SectionNotice extends HTMLElement {
      constructor() {
        super();

        var swiper = new Swiper("section-testimonial .swiper", {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: this.getAttribute("loop") == "true",
          centeredSlides: true,
          effect: this.getAttribute("effect"),
          autoplay: {
            delay: parseInt(this.getAttribute("duration")) * 1000,
            disableOnInteraction: false
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {},
          on: {},
          breakpoints: {
            750: {
              slidesPerView: parseInt(this.getAttribute('element')),
              spaceBetween: 0,
            }
          }
        });

        var testimonials = this.querySelectorAll('.testimonial-item');
        let max_height = 0;
        testimonials.forEach((test, i) => {
          if (i == 0) {
            max_height = test.getBoundingClientRect().height
          } else if (max_height < test.getBoundingClientRect().height) {
            max_height = test.getBoundingClientRect().height
          }
        })
        testimonials.forEach((test, i) => {
          test.style.height = max_height + 'px'
        })

        swiper.on("slideChange", function (slider) {
          /* slider.el.querySelector(".section-section-testimonial-link").addEventListener("mousemove", (e) => {
            e.stopPropagation()
            e.preventDefault()
            progress.style.display = "none"
          }) */
        })
      }
    }
  );
}
